// Static ds-track rail (adapted from Klargo-Reference/components/flow/FlowProgressTrack.tsx),
// simplified to a single-page snapshot: no cross-page animation/handoff since the seller
// journey stays on one route/component here. Backend/step logic is untouched.
import React from 'react';
import { VerifiedTick } from './StatusMark';

// Maps the page's real (non-contiguous) activeStep values to rail milestones.
// Registration and valuation (price) are captured together on one step, so
// there is no separate "valuation" milestone any more.
const MILESTONES = [
  { key: 'vehicle', atStep: 0 },
  { key: 'registration', atStep: 2 },
  { key: 'connection', atStep: 3 },
  { key: 'contract', atStep: 5 },
];

// `terminal`: the journey is over, so every stage is behind the reader (the reference's terminal
// position) and the rail says so. `completing`: the current stage is finishing right now - its mark
// draws its tick while the rail otherwise stands still, and the next mark does not become current.
const SellerFlowTrack = ({ activeStep, t, milestones = MILESTONES, ns = 'seller', terminal = false, completing = false }) => {
  const currentIndex = terminal
    ? milestones.length
    : Math.max(
      0,
      milestones.reduce((found, m, i) => (activeStep >= m.atStep ? i : found), 0),
    );

  return (
    <nav aria-label={t(`${ns}.track.label`)} className="ds-track" data-terminal={terminal ? 'true' : undefined}>
      <span className="ds-track-rule" aria-hidden="true" />
      <ol className="ds-track-list">
        {milestones.map((m, index) => {
          const drawing = completing && index === currentIndex;
          const state = index < currentIndex || drawing ? 'completed' : index === currentIndex ? 'current' : 'upcoming';
          return (
            <li
              key={m.key}
              className="ds-track-item"
              data-state={state}
              aria-current={state === 'current' ? 'step' : undefined}
              style={{ '--ds-track-at': String(index / (milestones.length - 1)) }}
            >
              <span className="ds-track-mark" data-advance={drawing ? 'complete' : undefined} aria-hidden="true">
                {state === 'completed' && <VerifiedTick className="ds-track-tick" width={10} height={9} />}
              </span>
              <span className="sr-only">
                {t(`${ns}.track.${m.key}`)} — {t(`seller.track.state.${state}`)}
              </span>
            </li>
          );
        })}
      </ol>
      {terminal && <span className="sr-only">{t(`${ns}.track.terminal`)}</span>}
    </nav>
  );
};

export default SellerFlowTrack;
